import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isEnglish, setIsEnglish] = useState(false);

  useEffect(() => {
    // i18n dil değişikliklerini dinle
    const handleLanguageChange = () => {
      const currentLang = i18n.language || 'tr';
      setIsEnglish(currentLang.startsWith('en'));
    };

    // Başlangıçta dil durumunu kontrol et
    handleLanguageChange();

    // Dil değişikliklerini dinle
    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
  };

  const baseClasses =
    'font-pixel text-[10px] px-3 py-2 transition-all duration-200';

  return (
    <div className="flex items-center border border-arcade-cyan/50 rounded bg-arcade-panel/80 backdrop-blur-sm overflow-hidden shadow-[0_0_10px_rgba(77,232,244,0.25)]">
      <button
        onClick={() => changeLanguage('tr')}
        aria-label="Türkçe"
        className={`${baseClasses} ${
          !isEnglish
            ? 'bg-arcade-cyan text-arcade-bg'
            : 'text-arcade-purple hover:text-arcade-cyan'
        }`}
      >
        TR
      </button>
      <button
        onClick={() => changeLanguage('en')}
        aria-label="English"
        className={`${baseClasses} ${
          isEnglish
            ? 'bg-arcade-cyan text-arcade-bg'
            : 'text-arcade-purple hover:text-arcade-cyan'
        }`}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
